export const ROLE_USER = 'ROLE_USER'
export const ROLE_ADMIN = 'ROLE_ADMIN'
export const ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN'
export const ROLE_SUPPLIER = 'ROLE_SUPPLIER'

export const COMPANY_EMPLOYEE = 'COMPANY_EMPLOYEE'
export const COMPANY_ADMIN = 'COMPANY_ADMIN'
export const COMPANY_SUPER_ADMIN = 'COMPANY_SUPER_ADMIN'

export const RMC_ROLE_USER = 'RMC_ROLE_USER'
export const RMC_ROLE_ADMIN = 'RMC_ROLE_ADMIN'
export const RMC_ROLE_BOOKER = 'RMC_ROLE_BOOKER'

export const roles = {
  user: {
    value: ROLE_USER,
    label: 'Company User',
  },
  admin: {
    value: ROLE_ADMIN,
    label: 'AltoVita user',
  },
  superAdmin: {
    value: ROLE_SUPER_ADMIN,
    label: 'Super admin',
  },
  supplier: {
    value: ROLE_SUPPLIER,
    label: 'Supplier',
  },
}

export const rolesCompany = {
  employee: {
    value: COMPANY_EMPLOYEE,
    label: 'Company employee',
  },
  admin: {
    value: COMPANY_ADMIN,
    label: 'Company admin',
  },
  superAdmin: {
    value: COMPANY_SUPER_ADMIN,
    label: 'Company super admin',
  },
}

export const systemRoles = {
  user: {
    value: ROLE_USER,
    label: 'User',
  },
  admin: {
    value: ROLE_ADMIN,
    label: 'AltoVita user',
  },
  superAdmin: {
    value: ROLE_SUPER_ADMIN,
    label: 'Super admin',
  },
  supplier: {
    value: ROLE_SUPPLIER,
    label: 'Supplier',
  },
}

export const rmcRoles = {
  user: {
    value: RMC_ROLE_USER,
    label: 'User',
  },
  admin: {
    value: RMC_ROLE_ADMIN,
    label: 'Admin',
  },
  booker: {
    value: RMC_ROLE_BOOKER,
    label: 'Booker',
  },
}

const roleRanks = [
  roles.superAdmin,
  roles.admin,
  roles.supplier,
  rmcRoles.admin,
  roles.user,
  rmcRoles.user,
  rmcRoles.booker,
]
export const getCurrentRole = (userRoles = [], rolesRanks = roleRanks) => {
  let currentRole = userRoles[userRoles.length - 1]
  for (let i = 0; i < rolesRanks.length; i++) {
    if (userRoles.includes(rolesRanks[i].value)) {
      currentRole = rolesRanks[i]
      break
    }
  }
  return currentRole
}

export const getCompanyAccess = (company) => {
  const access = {
    isSuperAdmin: false,
    isAdmin: false,
    isEmployee: true,
  }
  if (!company) return access

  const { role } = company

  if (role === rolesCompany.superAdmin.value) {
    access.isSuperAdmin = true
  } else if (role === rolesCompany.admin.value) {
    access.isAdmin = true
  } else if (role === rolesCompany.employee.value) {
    access.isEmployee = true
  }

  return access
}

export const userRolesAccesses = [
  'isSuperAdmin',
  'isAdmin',
  'isRmc',
  'isCompany',
  'isRmcUser',
  'isRmcAdmin',
  'isRmcBooker',
  'isSupplier',
]

export const USER_ROLE_KEY = {
  superAdmin: 'superAdmin',
  supplier: 'supplier',
  admin: 'admin',
  company: 'company',
  rmc: 'rmc',
} as const
